import React, { useState } from 'react'
import { Input } from '@pergas-common/pergas-components'
import { useSelector } from 'react-redux'
import { selectLocale } from '../redux/locale/selectors'

const NameInput = ({ disabled, onChangeInput }) => {
  const locale = useSelector(selectLocale)
  const [input, setInput] = useState('')

  return (
    <Input
      name='name'
      disabled={disabled}
      value={input}
      onChangeValue={(input) => {
        setInput(input.currentTarget.value)
        if (onChangeInput) {
          onChangeInput(input.currentTarget.value)
        }
      }}
      placeholder={`${locale.file_name}`}
    />
  )
}

export default NameInput
